/* eslint-disable no-underscore-dangle */
import { useState, useEffect, useContext } from 'react';

import { useLazyQuery } from '@apollo/client';

import { GeneralContext } from '../../../../core/app-context/GeneralContext';
import { GET_CORREIOS_CREDENTIALS } from './graphql';

export function useGetCorreiosCredentials({ storeId } = {}) {
  const { setLoading, setErrorMessage } = useContext(GeneralContext);
  const [isLoading, setIsLoading] = useState(false);
  const [credentials, setCredentials] = useState({
    correiosId: '',
    correiosPassword: '',
    correiosAdministrativeCode: '',
    correiosContract: '',
    correiosServiceCode: '',
    correiosPostageCard: '',
  });
  const [GetCorreiosCredentials, { loading: apiLoading }] = useLazyQuery(
    GET_CORREIOS_CREDENTIALS,
    { fetchPolicy: 'network-only' },
  );

  useEffect(() => {
    if (apiLoading) {
      setIsLoading(true);
      setLoading(true);
    } else {
      setIsLoading(false);
      setLoading(false);
    }
  }, [apiLoading]);

  async function getCorreiosCredentials(newStoreId) {
    try {
      const res = await GetCorreiosCredentials({
        variables: { storeId: newStoreId || storeId },
      });
      if (res.data.getCorreiosCredentials.code === 200) {
        const {
          correiosId,
          correiosPassword,
          correiosAdministrativeCode,
          correiosContract,
          correiosServiceCode,
          correiosPostageCard,
        } = res.data.getCorreiosCredentials.credentials;
        setCredentials({
          correiosId,
          correiosPassword,
          correiosAdministrativeCode,
          correiosContract,
          correiosServiceCode,
          correiosPostageCard,
        });
      } else {
        setCredentials({
          correiosId: '',
          correiosPassword: '',
          correiosAdministrativeCode: '',
          correiosContract: '',
          correiosServiceCode: '',
          correiosPostageCard: '',
        });
      }
    } catch (e) {
      setErrorMessage('Algo deu errado, tente novamente mais tarde.');
    }
  }

  useEffect(() => {
    if (storeId) {
      getCorreiosCredentials(storeId);
    }
  }, [storeId]);

  return {
    getCorreiosCredentials,
    credentials,
    setCredentials,
    loading: isLoading,
  };
}
